<template>
    <el-popover placement="bottom-start" width="310" trigger="click" :value="visible" @show="visible = true">
        <el-form :model="filterForm" ref="filterForm">
            <el-form-item size="small" prop="dateRange" label="Date Range">
                <el-date-picker
                v-model="filterForm.dateRange"
                format="MM/dd/yyyy"
                value-format="MM/dd/yyyy"
                type="daterange"
                range-separator="-"
                start-placeholder="Start date"
                end-placeholder="End date"
                style="width:100%;">
                </el-date-picker>
            </el-form-item>

            <el-form-item size="small" prop="segment" label="Segment" >
                <el-select v-model="filterForm.segment" placeholder="Segment" style="width:100%;">
                    <el-option v-for="(segment, index) in segmentRecords" :key="index" :label="segment" :value="segment"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item size="small" prop="brandName" label="Brand" >
                <el-select v-model="filterForm.brandName" placeholder="Brand" style="width:100%;">
                    <el-option v-for="(brandName, index) in brandRecords" :key="index" :label="brandName" :value="brandName"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item size="small" prop="auditedBy" label="Audited By" >
                <el-select v-model="filterForm.auditedBy" placeholder="Audited By" style="width:100%;">
                    <el-option v-for="(user, index) in userRecords" :key="index" :label="user" :value="user"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item size="small" prop="invoiceType" label="Invoice Type" >
                <el-select v-model="filterForm.invoiceType" placeholder="Invoice Type" style="width:100%;">
                    <el-option v-for="(invoiceType, index) in ['MFN','BULK','Template']" :key="index" :label="invoiceType" :value="invoiceType"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="danger" plain @click="handleClearFilter">Clear</el-button>
                <div style="float: right;">
                     <el-button size="small" type="info" plain @click="visible = false">Cancel</el-button>
                    <el-button size="small" type="primary" @click="handleFilter" style="width:8em">Filter</el-button>
                </div>
            </el-form-item>
        </el-form>
        <el-button size="small" type="primary" slot="reference" icon="mdi mdi-filter-menu"> Filter</el-button>
    </el-popover>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import * as type from '@/store/types';
import { bus } from '@/main';
export default {
    data(){
        return {
            visible: false,
            filterForm: {
				dateRange: '',
				brandName: '',
                segment: '',
                auditedBy: '',
                invoiceType: ''
			}
        }
    },
    computed: {
        ...mapGetters({
            brandRecords: `invoicerecords/getBrandRecords`,
            segmentRecords: `invoicerecords/getSegmentRecords`,
            userRecords: `invoicerecords/getUserRecords`
        })
        
    },
    created(){
        this.loadBrandRecords();
        this.loadSegmentRecords();
        this.loadUserRecords();
        
        bus.$on('clearFilter', this.handleClearFilter)
    },
    methods: {
        ...mapActions({
            loadInvoiceRecords: `invoicerecords/${type.GET_INVOICE_RECORDS}`,
            loadBrandRecords: `invoicerecords/${type.GET_BRAND_RECORDS}`,
            loadSegmentRecords: `invoicerecords/${type.GET_SEGMENT_RECORDS}`,
            loadUserRecords: `invoicerecords/${type.GET_USER_RECORDS}`
        }),
        handleFilter(){
            let startDate = this.filterForm.dateRange[0]
			let endDate =  this.filterForm.dateRange[1]
            let {brandName, segment, auditedBy, invoiceType  } = this.filterForm;

            this.loadInvoiceRecords({
                startDate,
                endDate,
                brandName,
                segment,
                firstName: auditedBy,
                invoiceType
            })
            this.visible = false;
        },
        handleClearFilter(){
            this.$refs['filterForm'].resetFields();
        }
    }
}
</script>